import React, { useState } from "react";

const DigitalCard = ({ tag, latestMap, onSetDigital }) => {
  const latest = latestMap?.[tag.name];
  const raw = latest?.last_value;

  const val = raw === "N/A" || raw === undefined || raw === null ? "N/A" : String(raw);
  const ts = latest?.timestamp ?? "N/A";

  const [sending, setSending] = useState(false);
  const [localErr, setLocalErr] = useState("");

  const sendValue = async (value) => {
    setLocalErr("");
    setSending(true);
    try {
      await onSetDigital(tag.id, value); // 0/1
    } catch (e) {
      setLocalErr("ارسال مقدار دیجیتال ناموفق بود");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="dg-card">
      <div className="dg-card-head">
        <div className="dg-card-title">{tag.name}</div>
        <div className="dg-card-sub">ID: {tag.id}</div>
      </div>

      <div className="dg-digital-state">
        <span className="dg-label">State</span>
        <span className="dg-value-strong">{val}</span>
      </div>

      <div className="dg-digital-buttons">
        <button className="dg-btn dg-btn-on" disabled={sending} onClick={() => sendValue(1)}>
          {sending ? "..." : "ON"}
        </button>
        <button className="dg-btn dg-btn-off" disabled={sending} onClick={() => sendValue(0)}>
          {sending ? "..." : "OFF"}
        </button>
      </div>

      {localErr && <div className="dg-local-error">{localErr}</div>}

      <div className="dg-row">
        <span className="dg-label">Timestamp</span>
        <span className="dg-value-soft">{ts}</span>
      </div>
    </div>
  );
};

export default DigitalCard;